/**
 * Magnific Popup
 */

(function($) {


    /**
     * Image link
     */
    $('.js-popup-link--image').magnificPopup({
        type: 'image'
    });


    /**
     * Inline content link
     */
    $('.js-popup-link--inline').magnificPopup({
      type:'inline',
      midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
      callbacks: {
        open: function() {
            var popupInstance = $.magnificPopup.instance,
                link = $(popupInstance.currItem.el[0]),
                data = link.data(),
                $popupContentEl = $(link.attr('href'));

            if ($popupContentEl.length > 0) {
                for (var prop in data) {
                    var $el = $popupContentEl.find('.set-' + prop);
                    if ($el.length > 0) {
                        $el.val(data[prop]);
                    }
                }
            }
        },
      }
    });


    $('.js-popup-gallery').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: '.js-popup-gallery__link--image', // the selector for gallery item
            type: 'image',
            gallery: {
              enabled: true,
              preload: [0,2],
            }
        });
    });


})(jQuery);
